// @flow
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Box,
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {useParams} from 'react-router-dom';
import SnackBar from '../../../components/SnackBar';
import {AsyncPaginate} from 'react-select-async-paginate';
import theme from '../../../theme';
import optionsParser from '../../../helpers/optionsParser';
import mapStateToRequest from '../../../helpers/mapStateToRequest';
import {api_get, api_put} from "../../../utils/Api";
import FormControl from "@material-ui/core/FormControl";
import LoadingApi from 'components/LoadingApi/LoadingApi';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    'overflow': 'visible',
  },
  mtop: {
    marginTop: 24,
  },
  mtop0: {
    marginTop: 0,
  },
  content: {
    padding: 0,
  },

  uploadedFiles: {
    marginTop: 10,
  },
}));

const Form = (props) => {
  const {id} = useParams();
  const {className, edit, ...rest} = props;
  const classes = useStyles();

  const [values, setValues] = useState({
    name: '',
    isValid: false,
    description: '',
    touched: {},
    errors: {},
    video: {},
    pdfs: [],
    active: true,
    is_draft: false,
    type_id: null,
    selectedChapters: [],
    levels: [],
    report_reason: '',
    status: "Pending",
    rejectReason: '',
  });
  const [message, setAlertMessage] = useState('');
  const [severity, setAlertSeverity] = useState('success');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (edit) {
      setLoading(true)
      api_get(`video-reports/${id}`).then((result) => {
        setLoading(false);
        const data = result.payload;
        setValues({
          'description':data.description,
          'content' : data.content,
          'user':data.user ,
          'reportReason':data.report_reason ,
          'priority': data.priority,
          'status': data.status || "Pending",
           'rejectReason': data?.reject_reason,

        });
      });
    }
  }, []);
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const showErrorMessage = (errors) => {
    Object.keys(errors).map(function(key, index) {
      if (index == 0) {
        setAlertSeverity('error');
        setAlertMessage(errors[key][0]);
        setOpen(true);
      }
    });
  };

  const getReportReason = async (search, prevData, page) => {
    const options = optionsParser(search, null, null, ['name']);
    const result = await api_get(`report-reasons?page=${page.page}${options}`);
    return {
      options: [...result.payload],
      hasMore: result.meta.current_page !== result.meta.last_page,
      additional: {
        page: result.meta.current_page + 1,
      },
    };
  };
  const reasonChange = (value) => {
    setValues({
      ...values,
      reportReason: value,
    });
  };
  const handleSubmit = () => {
    const requestValues = mapStateToRequest(values, []);
      if (requestValues?.status === "Rejected" && !requestValues?.rejectReason) {
          setAlertMessage("You need to add a reason");
               setAlertSeverity("warning");
               setOpen(true);
        }
        else{
            setLoading(true);
            if (edit) {
                api_put(`video-reports/${id}`,requestValues).then((result) => {
                  if (result.errors) {
                    showErrorMessage(result.errors);
                  } else {
                    setAlertSeverity('success');
                    setAlertMessage('video updated successfully');
                    setOpen(true);
                    setLoading(false);
                    window.location.href = '/contents/video-reports';
                  }
                });
              }
        }

  };
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseLoading = () => {
    setLoading(false);
    }
    

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <form autoComplete="off" noValidate>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <Card className={classes.root}>
              <CardContent>
                <TextField
                    fullWidth
                    label="Content"
                    name="content"
                    onChange={handleChange}
                    disabled
                    value={(values.content && values.content.name)|| ''}
                    variant="outlined"
                    size="small"
                />

                <Box mt={2} mb={1}>
                  <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      onChange={handleChange}
                      disabled
                      value={values.description || ''}
                      variant="outlined"
                      size="small"
                  />
                </Box>
                <Box mt={2} mb={1}>
                  <TextField
                      fullWidth
                      label="User"
                      name="user"
                      onChange={handleChange}
                      disabled
                      value={(values.user && (values.user.name+' '+values.user.last_name)) || ''}
                      variant="outlined"
                      size="small"
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Card className={classes.root}>
              <CardHeader title="Basic" />
              <Divider className={classes.mtop0} />
              <CardContent className={classes.mtop0}>
                <Box mt={0}>
                <AsyncPaginate
                     isClearable={true}
                    loadOptions={getReportReason}
                    value={values.reportReason}
                    onChange={reasonChange}
                    getOptionLabel={(option) => option.reason}
                    getOptionValue={(option) => option.id}
                    placeholder="Report reason"
                    additional={{
                      page: 1,
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        height: '53px',
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#000',
                        fontSize: theme.typography.fontSize,
                        fontFamily: theme.typography.fontFamily,
                      }),
                    }}
                    menuPortalTarget={document.querySelector('body')}
                />
                </Box>
                <Box mt={2}>
                  <TextField
                      fullWidth
                      label="Priority"
                      name="priority"
                      onChange={handleChange}
                      required
                      value={values.priority || ''}
                      variant="outlined"
                  />
                </Box>
                <Box mt={2}>
                  <FormControl variant="outlined" fullWidth>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={values.status}
                        onChange={handleChange}
                        name="status"
                    >
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="In progress">In progress</MenuItem>
                      <MenuItem value="Resolved">Resolved</MenuItem>
                      <MenuItem value="Rejected">Rejected</MenuItem>
                    </Select>
                  </FormControl>

                </Box>
                {
                values?.status === "Rejected" &&   <Box mt={3}>
                     <TextField
                          fullWidth
                          placeholder="Reject Reason"
                          name="rejectReason"
                          onChange={handleChange}
                          required
                          value={values.rejectReason}
                          variant="outlined"
                    />
                </Box>
                }
              </CardContent>
            </Card>

          </Grid>
        </Grid>
        <Box mt={3}>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
          >
            Save details
          </Button>
        </Box>
      </form>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        handleClose={handleClose}
      />
      <LoadingApi open={loading} onClick={handleCloseLoading}/>
    </div>
  );
};


Form.propTypes = {
  className: PropTypes.string,
  edit: PropTypes.bool,
  handleCloseLoading: PropTypes.func,
loading: PropTypes.bool,
};

export default Form;
